import React, { useState, useEffect } from 'react';
import { getVideos, uploadVideo, createExternalVideo, updateVideo, deleteVideo } from "../api/videoApi";
import { getImages, uploadImage, createExternalImage, updateImage, deleteImage } from "../api/imageApi";
import { getPdfs, uploadPdf, createExternalPdf, updatePdf, deletePdf } from "../api/pdfApi";
import { getLinks, createLink, updateLink, deleteLink } from "../api/linkApi";


const categories = ["News & Media", "Research", "Publications"];

function AdminManager({ mediaTypes = ["videos", "images", "pdfs", "links"] }) {
  const [media, setMedia] = useState({ videos: [], images: [], pdfs: [], links: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [newMedia, setNewMedia] = useState({
    title: "",
    url: "",
    file: null,
    category: "",
    isExternal: false, 
  });
  
  // Reset file or URL when switching between external and file upload
useEffect(() => {
  setNewMedia((prev) => ({
    ...prev,
    file: prev.isExternal ? null : prev.file, // Reset file if external
    url: prev.isExternal ? prev.url : "", // Reset URL if not external
  }));
}, [newMedia.isExternal]);
  
  const [editingMedia, setEditingMedia] = useState(null);

  useEffect(() => {
    const fetchMedia = async () => {
      try {
        console.log("Fetching media...");
  
        const fetchedMedia = {};
        if (mediaTypes.includes("videos")) fetchedMedia.videos = await getVideos();
        if (mediaTypes.includes("images")) fetchedMedia.images = await getImages();
        if (mediaTypes.includes("pdfs")) fetchedMedia.pdfs = await getPdfs();
        if (mediaTypes.includes("links")) fetchedMedia.links = await getLinks();
  
        console.log("Media fetched:", fetchedMedia);
        setMedia(fetchedMedia);
      } catch (err) {
        console.error("Error fetching media:", err);
        setError("Failed to load media.");
      } finally {
        setLoading(false);
      }
    };
  
    fetchMedia(); // ✅ Just call the function directly
  }, []);

  const handleDelete = async (id, type) => {
    try {
      if (type === "videos") await deleteVideo(id);
      if (type === "images") await deleteImage(id);
      if (type === "pdfs") await deletePdf(id);
      if (type === "links") await deleteLink(id);
      setMedia((prev) => ({ ...prev, [type]: prev[type].filter((item) => item._id !== id) }));
    } catch (err) {
      console.error("Error deleting:", err);
    }
  };

  // const handleCreate = async (type, isExternal = false) => {
  //   try {
  //     let createdItem;
      
  //     if (type === "videos") {
  //       createdItem = isExternal ? await createExternalVideo(newMedia) : await uploadVideo(newMedia);
  //     } 
  //     if (type === "images") {
  //       createdItem = isExternal ? await createExternalImage(newMedia) : await uploadImage(newMedia);
  //     }
  //     if (type === "pdfs") {
  //       createdItem = isExternal ? await createExternalPdf(newMedia) : await uploadPdf(newMedia);
  //     }
  //     if (type === "links") {
  //       createdItem = await createLink(newMedia);
  //     }
  
  //     if (createdItem) {
  //       setMedia((prev) => ({ ...prev, [type]: [...prev[type], createdItem] }));
  //     }
  //   } catch (err) {
  //     console.error("Error creating media:", err);
  //   }
  // };

  const handleCreate = async (type, isExternal = false) => {
    try {
      let createdItem;
  
      if (isExternal) {
        // Handle external URL submissions
        const data = {
          url: newMedia.url,
          title: newMedia.title,
          category: newMedia.category,
        };
  
        if (type === "videos") createdItem = await createExternalVideo(data);
        if (type === "images") createdItem = await createExternalImage(data);
        if (type === "pdfs") createdItem = await createExternalPdf(data);
        if (type === "links") createdItem = await createLink(data);
      } else {
        // Handle local file uploads
        const formData = new FormData();
        formData.append(type.slice(0, -1), newMedia.file); // "image", "video", "pdf"
        formData.append("title", newMedia.title);
        formData.append("category", newMedia.category);
  
        if (type === "videos") createdItem = await uploadVideo(formData);
        if (type === "images") createdItem = await uploadImage(formData);
        if (type === "pdfs") createdItem = await uploadPdf(formData);
      }
  
      if (createdItem) {
        setMedia((prev) => ({ ...prev, [type]: [...prev[type], createdItem] }));
      }
    } catch (err) {
      console.error("Error creating media:", err);
    }
  };

  // const handleCreate = async (type, isExternal) => {
  //   try {
  //     let createdItem;
  
  //     if (isExternal) {
  //       // Create external media (Video, Image, PDF, Link)
  //       if (type === "videos") createdItem = await createExternalVideo({
  //         url: newMedia.url,
  //         title: newMedia.title, // ✅ Send title
  //         category: newMedia.category,
  //       });
  //       if (type === "images") createdItem = await createExternalImage({
  //         url: newMedia.url,
  //         title: newMedia.title, // ✅ Send title
  //         category: newMedia.category,
  //       });
  //       if (type === "pdfs") createdItem = await createExternalPdf({
  //         url: newMedia.url,
  //         title: newMedia.title, // ✅ Send title
  //         category: newMedia.category,
  //       });
  //       if (type === "links") createdItem = await createLink({
  //         url: newMedia.url,
  //         title: newMedia.title, // ✅ Send title
  //         category: newMedia.category,
  //       });
  //     } else {
  //       // Upload a file (Video, Image, PDF)
  //       const formData = new FormData();
  //       formData.append("file", newMedia.file);
  //       formData.append("title", newMedia.title); // ✅ Include title
  //       formData.append("category", newMedia.category);
  
  //       if (type === "videos") createdItem = await uploadVideo(formData);
  //       if (type === "images") createdItem = await uploadImage(formData);
  //       if (type === "pdfs") createdItem = await uploadPdf(formData);
  //     }
  
  //     if (createdItem) {
  //       setMedia((prev) => ({
  //         ...prev,
  //         [type]: [...prev[type], createdItem],
  //       }));
  //     }
  //   } catch (err) {
  //     console.error("Error creating media:", err);
  //   }
  // };
  
  
  
  
  
  

  const handleUpdate = async (id, type) => {
    try {
      let updatedItem;
  
      if (type === "videos") {
        updatedItem = editingMedia.url
          ? await updateVideo(id, editingMedia) // Update external video
          : await uploadVideo(id, editingMedia); // Update uploaded video
      }
  
      if (type === "images") {
        updatedItem = editingMedia.url
          ? await updateImage(id, editingMedia) // Update external image
          : await uploadImage(id, editingMedia); // Update uploaded image
      }
  
      if (type === "pdfs") {
        updatedItem = editingMedia.url
          ? await updatePdf(id, editingMedia) // Update external PDF
          : await uploadPdf(id, editingMedia); // Update uploaded PDF
      }
  
      if (type === "links") {
        updatedItem = await updateLink(id, editingMedia);
      }
  
      if (updatedItem) {
        setMedia((prev) => ({
          ...prev,
          [type]: prev[type].map((item) => (item._id === id ? updatedItem : item)),
        }));
      }
    } catch (err) {
      console.error("Error updating media:", err);
    }
  };
  

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;


return (
  <div className="container mx-auto p-6">
    <h1 className="text-3xl font-bold mb-6">Admin Manager</h1>

    
    {/* <div className="grid grid-cols-3 gap-4 mb-4">
      <input
        type="text"
        placeholder="Title"
        value={newMedia.title}
        onChange={(e) => setNewMedia({ ...newMedia, title: e.target.value })}
        className="border p-2 rounded w-full"
      />
      <input
        type="text"
        placeholder="URL"
        value={newMedia.url}
        onChange={(e) => setNewMedia({ ...newMedia, url: e.target.value })}
        className="border p-2 rounded w-full"
      />
      <select
        value={newMedia.category}
        onChange={(e) => setNewMedia({ ...newMedia, category: e.target.value })}
        className="border p-2 rounded w-full"
      >
        <option value="">Select Category</option>
        {categories.map((cat) => (
          <option key={cat} value={cat}>{cat}</option>
        ))}
      </select>
    </div>

    
    <div className="flex flex-wrap gap-4 mb-6">
      {mediaTypes.includes("videos") && (
        <>
          <button className="bg-blue-500 text-white p-2 rounded" onClick={() => handleCreate("videos", false)}>Upload Video</button>
          <button className="bg-blue-300 text-white p-2 rounded" onClick={() => handleCreate("videos", true)}>Add External Video</button>
        </>
      )}
      {mediaTypes.includes("images") && (
        <>
          <button className="bg-green-500 text-white p-2 rounded" onClick={() => handleCreate("images", false)}>Upload Image</button>
          <button className="bg-green-300 text-white p-2 rounded" onClick={() => handleCreate("images", true)}>Add External Image</button>
        </>
      )}
      {mediaTypes.includes("pdfs") && (
        <>
          <button className="bg-purple-500 text-white p-2 rounded" onClick={() => handleCreate("pdfs", false)}>Upload PDF</button>
          <button className="bg-purple-300 text-white p-2 rounded" onClick={() => handleCreate("pdfs", true)}>Add External PDF</button>
        </>
      )}
      {mediaTypes.includes("links") && (
        <button className="bg-yellow-500 text-white p-2 rounded" onClick={() => handleCreate("links")}>Add Link</button>
      )}
    </div> */}

<div className="mb-4">
  <label className="mr-4">
    <input
      type="radio"
      name="uploadType"
      value="file"
      checked={!newMedia.isExternal}
      onChange={() => setNewMedia({ ...newMedia, isExternal: false, url: "" })}
    />
    Upload File
  </label>
  <label>
    <input
      type="radio"
      name="uploadType"
      value="external"
      checked={newMedia.isExternal}
      onChange={() => setNewMedia({ ...newMedia, isExternal: true, file: null })}
    />
    External URL
  </label>
</div>

{/* Title Input */}
<input
  type="text"
  placeholder="Title"
  value={newMedia.title}
  onChange={(e) => setNewMedia({ ...newMedia, title: e.target.value })}
  className="border rounded p-2 w-full mb-2"
/>

{/* Category Dropdown */}
<select
  value={newMedia.category}
  onChange={(e) => setNewMedia({ ...newMedia, category: e.target.value })}
  className="border rounded p-2 w-full mb-2"
>
  <option value="">Select Category</option>
  {categories.map((cat) => (
    <option key={cat} value={cat}>{cat}</option>
  ))}
</select>

{/* Conditionally Render File Input or URL Input */}
{newMedia.isExternal ? (
  <input
    type="text"
    placeholder="External URL"
    value={newMedia.url || ""}
    onChange={(e) => setNewMedia({ ...newMedia, url: e.target.value, file: null })}
    className="border rounded p-2 w-full mb-2"
  />
) : (
  <input
    type="file"
    onChange={(e) => setNewMedia({ ...newMedia, file: e.target.files[0], url: "" })}
    className="border rounded p-2 w-full mb-2"
  />
)}



{/* Buttons for Uploading Local Files and Adding External URLs */}
<div className="flex gap-2">
  {mediaTypes.includes("videos") && (
    <>
      <button onClick={() => handleCreate("videos", false)} className="bg-blue-500 text-white px-4 py-2 rounded">
        Upload Video
      </button>
      <button onClick={() => handleCreate("videos", true)} className="bg-gray-500 text-white px-4 py-2 rounded">
        Add External Video
      </button>
    </>
  )}
  {mediaTypes.includes("images") && (
    <>
      <button onClick={() => handleCreate("images", false)} className="bg-blue-500 text-white px-4 py-2 rounded">
        Upload Image
      </button>
      <button onClick={() => handleCreate("images", true)} className="bg-gray-500 text-white px-4 py-2 rounded">
        Add External Image
      </button>
    </>
  )}
  {mediaTypes.includes("pdfs") && (
    <>
      <button onClick={() => handleCreate("pdfs", false)} className="bg-blue-500 text-white px-4 py-2 rounded">
        Upload PDF
      </button>
      <button onClick={() => handleCreate("pdfs", true)} className="bg-gray-500 text-white px-4 py-2 rounded">
        Add External PDF
      </button>
    </>
  )}
  {mediaTypes.includes("links") && (
    <button onClick={() => handleCreate("links", true)} className="bg-green-500 text-white px-4 py-2 rounded">
      Add Link
    </button>
  )}
</div>


    
    {mediaTypes.map((type) => (
      <div key={type} className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">{type.charAt(0).toUpperCase() + type.slice(1)}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {media[type]?.map((item) => (
            <div key={item._id} className="border p-4 rounded shadow-md">
              {editingMedia?._id === item._id ? (
                <>
                  <input
                    type="text"
                    value={editingMedia.title || editingMedia.caption}
                    onChange={(e) => setEditingMedia({ ...editingMedia, title: e.target.value })}
                    className="border p-2 rounded w-full mb-2"
                  />
                  <input
                    type="text"
                    value={editingMedia.url}
                    onChange={(e) => setEditingMedia({ ...editingMedia, url: e.target.value })}
                    className="border p-2 rounded w-full mb-2"
                  />
                  <button className="bg-yellow-500 text-white p-2 rounded w-full" onClick={() => handleUpdate(item._id, type)}>Save Changes</button>
                </>
              ) : (
                <>
                  <h3 className="text-lg font-semibold">{item.title || item.caption}</h3>
                  <p className="text-gray-500">{item.category}</p>
                  <div className="flex justify-between mt-2">
                    <button className="bg-red-500 text-white p-2 rounded" onClick={() => handleDelete(item._id, type)}>Delete</button>
                    <button className="bg-blue-500 text-white p-2 rounded" onClick={() => setEditingMedia(item)}>Edit</button>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);

// return (
//   <div className="container mx-auto p-6">
//     <h1 className="text-3xl font-bold mb-6 text-center">Admin Manager</h1>

//     {/* Media Upload Form */}
//     <div className="border p-6 rounded-lg shadow-lg bg-white mb-6">
//       <h2 className="text-xl font-semibold mb-4">Add New Media</h2>

//       <input
//         type="text"
//         placeholder="Title"
//         value={newMedia.title}
//         onChange={(e) => setNewMedia({ ...newMedia, title: e.target.value })}
//         className="border rounded p-2 w-full mb-2"
//       />

//       {/* Media Type Selection */}
//       <select
//         value={newMedia.category}
//         onChange={(e) => setNewMedia({ ...newMedia, category: e.target.value })}
//         className="border rounded p-2 w-full mb-2"
//       >
//         <option value="">Select Category</option>
//         {categories.map((cat) => (
//           <option key={cat} value={cat}>
//             {cat}
//           </option>
//         ))}
//       </select>

//       {/* Upload Type Selection */}
//       <div className="flex items-center space-x-4 mb-4">
//         <label className="flex items-center space-x-2">
//           <input
//             type="radio"
//             name="uploadType"
//             checked={!newMedia.isExternal}
//             onChange={() => setNewMedia({ ...newMedia, isExternal: false })}
//           />
//           <span>Upload File</span>
//         </label>

//         <label className="flex items-center space-x-2">
//           <input
//             type="radio"
//             name="uploadType"
//             checked={newMedia.isExternal}
//             onChange={() => setNewMedia({ ...newMedia, isExternal: true })}
//           />
//           <span>External URL</span>
//         </label>
//       </div>

//       {/* Conditionally Render File Input or URL Input */}
//       {newMedia.isExternal ? (
//         <input
//           type="text"
//           placeholder="External URL"
//           value={newMedia.url}
//           onChange={(e) => setNewMedia({ ...newMedia, url: e.target.value })}
//           className="border rounded p-2 w-full mb-4"
//         />
//       ) : (
//         <input
//           type="file"
//           onChange={(e) => setNewMedia({ ...newMedia, file: e.target.files[0] })}
//           className="border rounded p-2 w-full mb-4"
//         />
//       )}

//       {/* Upload Buttons */}
//       <div className="flex flex-wrap gap-2">
//         {mediaTypes.includes("videos") && (
//           <>
//             <button onClick={() => handleCreate("videos", false)} className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
//               Upload Video
//             </button>
//             <button onClick={() => handleCreate("videos", true)} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">
//               Add External Video
//             </button>
//           </>
//         )}
//         {mediaTypes.includes("images") && (
//           <>
//             <button onClick={() => handleCreate("images", false)} className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
//               Upload Image
//             </button>
//             <button onClick={() => handleCreate("images", true)} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">
//               Add External Image
//             </button>
//           </>
//         )}
//         {mediaTypes.includes("pdfs") && (
//           <>
//             <button onClick={() => handleCreate("pdfs", false)} className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
//               Upload PDF
//             </button>
//             <button onClick={() => handleCreate("pdfs", true)} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">
//               Add External PDF
//             </button>
//           </>
//         )}
//         {mediaTypes.includes("links") && (
//           <button onClick={() => handleCreate("links")} className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600">
//             Add Link
//           </button>
//         )}
//       </div>
//     </div>

//     {/* Display Media List */}
//     {mediaTypes.map((type) => (
//       <div key={type} className="border p-6 rounded-lg shadow-lg bg-white mb-6">
//         <h2 className="text-2xl font-semibold mb-4 capitalize">{type}</h2>
//         <ul className="divide-y divide-gray-200">
//           {media[type]?.map((item) => (
//             <li key={item._id} className="py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between">
//               {editingMedia?._id === item._id ? (
//                 <>
//                   <input
//                     type="text"
//                     value={editingMedia.title}
//                     onChange={(e) => setEditingMedia({ ...editingMedia, title: e.target.value })}
//                     className="border p-2 rounded w-full mb-2"
//                   />
//                   <div className="flex gap-2">
//                     <button onClick={() => handleUpdate(item._id, type)} className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600">
//                       Save Changes
//                     </button>
//                     <button onClick={() => setEditingMedia(null)} className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600">
//                       Cancel
//                     </button>
//                   </div>
//                 </>
//               ) : (
//                 <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between w-full">
//                   <span className="font-medium text-lg">{item.title} ({item.category})</span>
//                   <div className="flex gap-2">
//                     <button onClick={() => setEditingMedia(item)} className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600">
//                       Edit
//                     </button>
//                     <button onClick={() => handleDelete(item._id, type)} className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600">
//                       Delete
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </li>
//           ))}
//         </ul>
//       </div>
//     ))}
//   </div>
// );


}

export default AdminManager;